import { Button, ButtonVariant, ButtonSize, Hide } from "shared/components";
import { User03 } from "untitledui-js-base";
import { useTemplateContext } from "../provider";

export const CoSignerDisabledSlice = () => {
  const { template, savedTemplate, setTemplate, readOnly } =
    useTemplateContext();

  const enableCoSigner = () => {
    if (!template || !savedTemplate) return;

    setTemplate({
      ...template,
      settings: {
        ...template.settings,
        co_signer: {
          ...template.settings.co_signer,
          enabled_screening_services: true
        }
      },
      verification_schemas: {
        ...template.verification_schemas,
        co_signer: {
          ...savedTemplate.verification_schemas.applicant
        }
      }
    });
  };

  return (
    <div className="flex flex-col items-center justify-center h-full space-y-6 animate-appear">
      <div className="p-[30px] rounded-full bg-alpha-20">
        <User03 size="40" className="stroke-content-400" />
      </div>
      <div className="space-y-2 text-center">
        <p className="text-base text-content-500 font-bold">
          Guarantors are not allowed for this template
        </p>
        <Hide if={readOnly}>
          <p className="text-sm text-content-300 font-medium">
            Click the button below to allow inviting guarantors to the
            application
          </p>
        </Hide>
      </div>
      <Hide if={readOnly}>
        <Button
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.SM}
          onClick={() => enableCoSigner()}
        >
          Allow guarantors
        </Button>
      </Hide>
    </div>
  );
};
